/**
 * Creates a FairPlay session key by concatenating the provided init
 * data, content ID, and certificate into a single `Uint8Array`.
 */

const createKey = (
    initData: Uint8Array,
    contentId: Uint16Array,
    certificate: Uint8Array
): Uint8Array => {
    const BITS = 4;

    let writeIndex  = 0;

    const buffer = new ArrayBuffer(
        initData.byteLength + BITS +
        contentId.byteLength + BITS +
        certificate.byteLength + BITS
    );

    const dataView = new DataView(buffer);

    const arr1 = new Uint8Array(buffer, writeIndex, initData.byteLength);

    arr1.set(initData);

    writeIndex += initData.byteLength;

    dataView.setUint32(writeIndex, contentId.byteLength, true);

    writeIndex += BITS;

    const arr2 = new Uint16Array(buffer, writeIndex, contentId.length);

    arr2.set(contentId);

    writeIndex += arr2.byteLength;

    dataView.setUint32(writeIndex, certificate.byteLength, true);

    writeIndex += BITS;

    const arr3 = new Uint8Array(buffer, writeIndex, certificate.byteLength);

    arr3.set(certificate);

    return new Uint8Array(buffer, 0, buffer.byteLength);
};

export default createKey;